import React from 'react'
import { Fragment, useEffect, useRef, useState } from 'react'

export default function Button(props) {

    return (
        <>
            <span className={"flex flex-col " + props.className}>
                <label className="text-left pl-2 text-gray-700">{props.label}</label>
                <input className="rounded-md w-full h-10 border-gray-200" defaultValue={props.defaultValue} type={props.type} placeholder={props.placeholder}
                    onChange={e => props.handleChange(e)}
                />
            </span>
        </>
    )
}